'use client';

import type { Activity } from '../../../../../services/activities.service';
import { ActivityOwnerActions } from './ActivityOwnerActions';

interface ActivityOwnerActionsClientProps {
  activity: Activity;
}

/**
 * Client wrapper for ActivityOwnerActions.
 * This is used as a Suspense boundary target in server components.
 * Renders nothing during SSR, shows owner actions after hydration if user is owner.
 */
export function ActivityOwnerActionsClient({ activity }: ActivityOwnerActionsClientProps) {
  return <ActivityOwnerActions activity={activity} />;
}
